var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoyalCrownSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "982px",
    height: "671px",
    viewBox: "0 0 982 671",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "royal-crown-svgrepo-com") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "royal-crown-svgrepo-com",
    transform: "translate(0.002000, 0.850000)",
    fill: "#61A351",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.398,354 C66.298,354 67.098,354 67.998,353.9 L155.198,669.5 L490.998,669.5 L826.698,669.5 L913.898,353.9 C914.797,353.9 915.597,354 916.498,354 C952.598,354 981.898,324.7 981.898,288.6 C981.898,252.5 952.597,223.2 916.498,223.2 C880.399,223.2 851.098,252.5 851.098,288.6 C851.098,295.6 852.199,302.4 854.298,308.7 L696.598,400.9 L527.098,119.9 C544.699,108.2 556.399,88.1 556.399,65.4 C556.399,29.3 527.098,0 490.999,0 C454.9,0 425.599,29.3 425.599,65.4 C425.599,88.2 437.2,108.2 454.9,119.9 L285.4,400.9 L127.7,308.7 C129.7,302.4 130.9,295.6 130.9,288.6 C130.9,252.5 101.6,223.2 65.5,223.2 C29.3,223.2 0,252.5 0,288.6 C0,324.7 29.298,354 65.398,354 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyalCrownSvgrepoCom);
export default __webpack_public_path__ + "static/media/royal-crown-svgrepo-com.f8cf5b6bebb383acddedc6c348a20cca.svg";
export { ForwardRef as ReactComponent };